import styles from "./index.module.css";
import React, { useState } from "react";
import { Auth } from "shared/@auth/Auth";

import Generate from "./Generate";
import History from "./History";

const IBOLogin = ({ iboNumber }) => {
  const { hasPermission } = Auth.useContainer();
  const [activeOutput, setActiveOutput] = useState(null);

  return (
    <div className={styles.container}>
      {hasPermission("ibologin.password.create") && (
        <Generate
          iboNumber={iboNumber}
          activeOutput={activeOutput}
          setActiveOutput={setActiveOutput}
        />
      )}

      {hasPermission("ibologin.history.read") && activeOutput !== "otp" && (
        <History iboNumber={iboNumber} />
      )}
    </div>
  );
};

export default IBOLogin;
